<template>
    <div class="alert alert-warning-soft show flex mb-1 justify-center text-base" role="alert">
        <AlertCircleIcon class="w-6 h-6 mr-2" /> ข้อมูลยังไม่ได้บันทึก กรุณากดปุ่มบันทึกและถัดไป เพื่อดำเนินการในขั้นตอนถัดไปและบันทึกแบบสอบถามให้เรียบร้อย
    </div>
</template>